import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/base/SchemaOrg';
import HeroCarousel from './components/HeroCarousel';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import { featuredMovies, hotMovies, newMovies, movies, categories } from '@/mocks/movies';

export default function Home() {
  const carouselItems = featuredMovies.slice(0, 5);

  return (
    <>
      <ScrollToTop />
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="黄瓜影视在线看·免费高清影视全集 - 海量电影电视剧综艺动漫在线观看"
        description="黄瓜影视在线看，海量高清影视资源免费畅享，涵盖热门电影、电视剧、综艺、动漫等全类型内容，无需下载即可流畅在线观看。"
        url="https://huanggua.tv"
      />

      <div className="min-h-screen" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
        <Navbar />

        <main>
          <HeroCarousel items={carouselItems} />

          <CategoryNav />

          <MovieGrid
            title="热门推荐"
            subtitle="大家都在看的精彩内容"
            items={hotMovies.slice(0, 12)}
            icon="ri-fire-line"
          />

          <div className="w-full px-4 md:px-6 lg:px-8">
            <div className="relative rounded-2xl overflow-hidden my-6 h-[180px] md:h-[220px]">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20cinema%20atmosphere%20with%20warm%20theater%20lights%2C%20dark%20elegant%20movie%20theater%20interior%20with%20red%20velvet%20curtains%2C%20golden%20spotlights%2C%20cinematic%20ambiance%2C%20luxury%20theater%20setting%2C%20warm%20golden%20and%20deep%20red%20accents%2C%20dramatic%20lighting%2C%20elegant%20composition&width=1600&height=440&seq=home-banner&orientation=landscape"
                alt="黄瓜影视 - 免费高清影视在线观看"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
              <div className="absolute inset-0 flex items-center px-8 md:px-12">
                <div className="max-w-md">
                  <h3 className="text-xl md:text-2xl font-bold font-heading text-white mb-2">随时随地，畅享高清影视</h3>
                  <p className="text-sm text-white/70 mb-4">无需下载，打开浏览器即可观看 · 支持电脑、平板、手机多终端</p>
                  <div className="flex gap-2">
                    {categories.slice(0, 3).map(cat => (
                      <span key={cat.slug} className="px-3 py-1 rounded-full text-xs bg-white/15 text-white whitespace-nowrap">{cat.label}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <MovieGrid
            title="最新更新"
            subtitle="每日更新，精彩不断"
            items={newMovies.slice(0, 12)}
            icon="ri-timer-flash-line"
          />

          <MovieGrid
            title="高分推荐"
            subtitle="评分最高的精选内容"
            items={[...movies].sort((a, b) => b.rating - a.rating).slice(0, 12)}
            icon="ri-star-line"
          />
        </main>

        <Footer />
      </div>
    </>
  );
}